if (document.querySelector('#customSlider')) {
    class CustomSlider {
        constructor(element) {
            this.slider = element;
            this.track = element.querySelector('.slider-track');
            this.slides = Array.from(this.track.children);
            this.nextButton = element.querySelector('.slider-nav.next');
            this.prevButton = element.querySelector('.slider-nav.prev');
            this.nextEl = element.querySelector('.gradient-overlay.next');
            this.prevEl = element.querySelector('.gradient-overlay.prev');
            this.pagination = element.querySelector('.slider-pagination');
            
            this.currentIndex = 0;
            this.slidesCount = this.slides.length;
            this.slideWidth = 0;
            this.isTransitioning = false;
            this.numberOfClones = 4;
            this.isLooping = false;
            
            this.isDragging = false;
            this.startPos = 0;
            this.currentTranslate = 0;
            this.prevTranslate = 0;
            this.dragThreshold = 50; // minimum distance for a swipe
            
            this.init();
        }
        
        init() {
            // Clone slides for infinite loop
            const originalSlides = [...this.slides];
            
            // Add clones to both ends
            for (let i = 0; i < this.numberOfClones; i++) {
                const endClone = originalSlides[i % originalSlides.length].cloneNode(true);
                this.track.appendChild(endClone);
                
                const startClone = originalSlides[originalSlides.length - 1 - (i % originalSlides.length)].cloneNode(true);
                this.track.insertBefore(startClone, this.track.firstChild);
            }
            
            // Update slides array with clones
            this.slides = Array.from(this.track.children);
            this.slidesCount = this.slides.length;
            
            // Set initial position
            this.currentIndex = this.numberOfClones;
            
            // Create pagination
            this.setupPagination();
            
            // Setup event listeners
            this.setupEventListeners();
            
            // Initial setup
            setTimeout(() => {
                this.calculateDimensions();
                this.updateSlidePosition(false);
                this.setActiveSlide(this.currentIndex);
                this.slider.style.opacity = '1';
            }, 100);
        }
        
        setupEventListeners() {
            // Navigation buttons and overlays
            this.nextButton.addEventListener('click', () => this.nextSlide());
            this.prevButton.addEventListener('click', () => this.prevSlide());
            this.nextEl.addEventListener('click', () => this.nextSlide());
            this.prevEl.addEventListener('click', () => this.prevSlide());
        
            // Add click listeners to slides
            this.slides.forEach((slide, index) => {
                slide.addEventListener('click', () => {
                    if (!slide.classList.contains('active') && !this.isTransitioning && !this.isLooping) {
                        // If clicking a slide to the right of the active slide, go next
                        if (index > this.currentIndex) {
                            this.nextSlide();
                        }
                        // If clicking a slide to the left of the active slide, go previous
                        else if (index < this.currentIndex) {
                            this.prevSlide();
                        }
                    }
                });
            });
            
            // Transition end
            this.track.addEventListener('transitionend', () => this.handleTransitionEnd());
            
            // Window resize
            window.addEventListener('resize', () => {
                this.calculateDimensions();
                this.setActiveSlide(this.currentIndex);
                this.updateSlidePosition(false);
            });

            // Add touch/mouse event listeners
            this.track.addEventListener('mousedown', (e) => this.startDragging(e));
            this.track.addEventListener('touchstart', (e) => this.startDragging(e));
            
            window.addEventListener('mousemove', (e) => this.drag(e));
            window.addEventListener('touchmove', (e) => this.drag(e));
            
            window.addEventListener('mouseup', () => this.stopDragging());
            window.addEventListener('touchend', () => this.stopDragging());
            
            // Prevent context menu on long press
            this.track.addEventListener('contextmenu', (e) => e.preventDefault());
        }
        
        setupPagination() {
            // Clear existing pagination
            this.pagination.innerHTML = '';
            
            // Calculate number of actual slides (excluding clones)
            const actualSlidesCount = this.slidesCount - (this.numberOfClones * 2);
            
            // Create pagination dots
            for (let i = 0; i < actualSlidesCount; i++) {
                const dot = document.createElement('div');
                dot.classList.add('dot');
                dot.addEventListener('click', () => {
                    if (!this.isTransitioning && !this.isLooping) {
                        this.goToSlide(i + this.numberOfClones);
                    }
                });
                this.pagination.appendChild(dot);
            }
            
            this.paginationDots = Array.from(this.pagination.children);
        }
        
        calculateDimensions() {
            const containerWidth = this.slider.offsetWidth;
            this.containerWidth = containerWidth;
            
            // Get the actual slide widths from CSS
            const tempSlide = this.slides[0];
            tempSlide.classList.remove('active');
            this.inactiveSlideWidth = tempSlide.offsetWidth;
            tempSlide.classList.add('active');
            this.activeSlideWidth = tempSlide.offsetWidth;
            tempSlide.classList.remove('active');
            
            // Calculate the offset to center the active slide
            this.offset = (containerWidth - this.activeSlideWidth) / 2;
        }        
        
        updateSlidePosition(animate = true) {
            if (animate && !this.isLooping) {
                this.track.style.transition = 'transform 700ms ease-out';
            } else {
                this.track.style.transition = 'none';
            }
            
            let position = 0;
            // Calculate total width of slides before the current one
            for (let i = 0; i < this.currentIndex; i++) {
                position += this.slides[i].offsetWidth;
            }
            
            // Center the active slide
            position = -position + this.offset;
            
            this.track.style.transform = `translateX(${position}px)`;
        }
        
        setActiveSlide(index) {
            if (this.isLooping) return;
            
            this.slides.forEach(slide => {
                slide.style.width = `${this.inactiveSlideWidth}px`;
                slide.classList.remove('active');
            });
            
            const activeSlide = this.slides[index];
            if (activeSlide) {
                activeSlide.style.width = `${this.activeSlideWidth}px`;
                activeSlide.classList.add('active');
            }
            
            const actualIndex = index - this.numberOfClones;
            this.paginationDots.forEach((dot, i) => {
                dot.classList.toggle('active', i === actualIndex);
            });
        }
        
        goToSlide(index) {
            if (this.isTransitioning) return;
            this.isTransitioning = true;
            this.currentIndex = index;
            this.setActiveSlide(this.currentIndex);
            this.updateSlidePosition();
        }
        
        nextSlide() {
            if (this.isTransitioning || this.isLooping) return;
            
            // Check if we need to loop
            if (this.currentIndex >= this.slidesCount - this.numberOfClones - 1) {
                // Prepare for loop
                this.isLooping = true;
                
                // Disable transitions
                this.track.style.transition = 'none';
                this.slides.forEach(slide => {
                    slide.style.transition = 'none';
                });
                
                // Reset to first real slide
                this.currentIndex = this.numberOfClones - 1;
                this.updateSlidePosition(false);
                
                // Force reflow
                this.track.offsetHeight;
                
                // Re-enable transitions
                this.track.style.transition = 'transform 700ms ease-out';
                this.slides.forEach(slide => {
                    slide.style.transition = 'width 700ms ease-out';
                });
                
                this.isLooping = false;
            }
            
            // Proceed with normal slide change
            this.isTransitioning = true;
            this.currentIndex++;
            this.setActiveSlide(this.currentIndex);
            this.updateSlidePosition(true);
        }
        
        prevSlide() {
            if (this.isTransitioning || this.isLooping) return;
            
            // Check if we need to loop
            if (this.currentIndex <= this.numberOfClones) {
                // Prepare for loop
                this.isLooping = true;
                
                // Disable transitions
                this.track.style.transition = 'none';
                this.slides.forEach(slide => {
                    slide.style.transition = 'none';
                });
                
                // Reset to last real slide
                this.currentIndex = this.slidesCount - this.numberOfClones;
                this.updateSlidePosition(false);
                
                // Force reflow
                this.track.offsetHeight;
                
                // Re-enable transitions
                this.track.style.transition = 'transform 700ms ease-out';
                this.slides.forEach(slide => {
                    slide.style.transition = 'width 700ms ease-out';
                });
                
                this.isLooping = false;
            }
            
            // Proceed with normal slide change
            this.isTransitioning = true;
            this.currentIndex--;
            this.setActiveSlide(this.currentIndex);
            this.updateSlidePosition(true);
        }
        
        handleTransitionEnd() {
            this.isTransitioning = false;
        }

        startDragging(e) {
            if (this.isTransitioning || this.isLooping) return;
            
            this.isDragging = true;
            this.startPos = this.getPositionX(e);
            this.track.style.transition = 'none';
            this.slides.forEach(slide => {
                slide.style.transition = 'none';
            });
        }
        
        drag(e) {
            if (!this.isDragging) return;
            
            const currentPosition = this.getPositionX(e);
            const diff = currentPosition - this.startPos;
            
            // Calculate current position of track
            let position = 0;
            for (let i = 0; i < this.currentIndex; i++) {
                position += this.slides[i].offsetWidth;
            }
            position = -position + this.offset;
            
            // Update track position while dragging
            this.track.style.transform = `translateX(${position + diff}px)`;
        }
        
        stopDragging() {
            if (!this.isDragging) return;
            
            this.isDragging = false;
            const currentPosition = parseFloat(this.track.style.transform.replace('translateX(', ''));
            const diff = currentPosition - (-this.getCurrentPosition() + this.offset);
            
            // Re-enable transitions
            this.track.style.transition = 'transform 700ms ease-out';
            this.slides.forEach(slide => {
                slide.style.transition = 'width 700ms ease-out';
            });
            
            // Determine if we should move to next/prev slide
            if (Math.abs(diff) > this.dragThreshold) {
                if (diff > 0) {
                    this.prevSlide();
                } else {
                    this.nextSlide();
                }
            } else {
                // Snap back to current slide
                this.updateSlidePosition(true);
            }
        }
        
        getPositionX(e) {
            return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
        }
        
        getCurrentPosition() {
            let position = 0;
            for (let i = 0; i < this.currentIndex; i++) {
                position += this.slides[i].offsetWidth;
            }
            return position;
        }
    }
    
    // Initialize the slider
    document.addEventListener('DOMContentLoaded', () => {
        const slider = new CustomSlider(document.getElementById('customSlider'));
    });
}